const { h, render, Component } = require('preact');
const GrouponValidate = require ("../../../groupon/frontend/validate")

class Description extends Component {
  constructor(props) {
    super(props);
    this.changeDescriptionBoxState = this.changeDescriptionBoxState.bind(this)
    this.isInputValid = this.isInputValid.bind(this)
    this.readInput = this.readInput.bind(this)
    this.isInputGiven = this.isInputGiven.bind(this)
    this.validateFormDescription = this.validateFormDescription.bind(this)
    this.populateInput = this.populateInput.bind(this)
  }

  changeDescriptionBoxState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.validateFormDescription())
  }

  isInputGiven() {
    return this.getDescriptionElement().value.trim().length > 0
  }

  readInput() {
    return this.getDescriptionElement().value.trim()
  }

  isInputValid() {
    return this.validateDescription()
  }

  validateFormDescription() {
    if (this.props.attrs.required == "true") {
      return this.isInputGiven() && this.isInputValid()
    }
    else
      return true
  }

  validateDescription() {
     var  isCreditInformation = GrouponValidate.creditCard(this.readInput())
      if (isCreditInformation)
        this.creditElement().style.display = 'block'
      else
        this.creditElement().style.display = 'none'
      return !isCreditInformation
  }

  populateInput() {
    var data = {}
    if (this.isInputGiven()) {
      var inputData = this.readInput()
      data.description = `\n\n ${this.props.attrs.label} : ${inputData}`
    }
  }

  creditElement() {
   return document.getElementsByClassName('credit_card_warning')[0]
  }

  getDescriptionElement() {
    var elementId = 'description' + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  componentDidMount() {
    var descriptionElement = this.getDescriptionElement()
    if (descriptionElement) {
      descriptionElement.addEventListener("keyup", this.changeDescriptionBoxState)
    }
  }

  render() {
    let attrs = this.props.attrs
    let placeholder = attrs.attributes ? ( attributes.description ? attrs.attributes.description.placeHolder : null ) : null
    return (
      <div>
        <div class="row">
          <label for="">
            <strong id='ticket_description'>
              {attrs.label}
              {attrs.required == "true" ? (<span class="mandatory-field"> * </span>) : null}
            </strong>
          </label>
          <textarea class="description support_textbox p10" name="description" cols="80" rows="10" placeholder={placeholder} aria-label="Description" id={"description" + attrs.counter}></textarea>
        </div>
        <div class="row credit_card_warning invalid-input error initially-hidden">
          {I18n.translate('js.modules.support.invalid_description')}
          <span class="mandatory-field">*</span>
        </div>
      </div>
    )
  }
}

module.exports = Description
